import React from "react";

export default function CopyStep3() {
  return (
    <div>
      <div className="flex gap-2.5">
        <div className="shrink-0 border border-icon/50 w-8 h-8 rounded-full flex justify-center items-center text-lg font-semibold text-icon">
          3
        </div>
        <h1 className="">
          Aqui, clique em <b>ABRIR CONTA ADICIONAL</b>.
        </h1>
      </div>
      <div className="mt-2.5 ml-[42px]">
        <img
          src="https://media.atomicatpages.net/u/0BVrOWOoOHYYehGtCMVYjXF1KZk1/Pictures/6f5kr/n2l5x/JYIzuc0720161.jpeg"
          className="w-72"
          alt=""
        />
      </div>
    </div>
  );
}
